import React from "react";
import classNames from "classnames";
import { Tooltip } from "@blueprintjs/core";
import ClipIcon from "icons/paper-clip.svg";
import * as styles from "./styles.module.scss";
const UsedInResultsIcon = ({ entityType, count, className }) => (React.createElement(Tooltip, { minimal: true, openOnTargetFocus: false, placement: "bottom", usePortal: false, targetTagName: "div", content: React.createElement("div", { className: styles.tooltipContent },
        "This ",
        entityType,
        " is used in ",
        count,
        " results."), className: classNames(styles.target, className), portalClassName: styles.portal, popoverClassName: styles.tooltip },
    React.createElement("div", { className: styles.content },
        React.createElement("p", { className: styles.count }, count),
        React.createElement(ClipIcon, { className: styles.icon }))));
export default UsedInResultsIcon;
